<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Received Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="fromDate"/> ~ <CustomDatePicker v-model="toDate"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="vendorCode" ph="Vendor Code" :showName="false" :vendorOnly="true" @set-partner="setPartner" />
				</span>

				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div>
			<div style="margin: 0 auto;">
				<div class="al_center" style="margin: 0 auto;">
					<label class="mgr_5">
						<em class="lt_text">Carton</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.carton | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Qty</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.qty | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Amount</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.amount | toCurrency" />
					</label>
				</div>
			</div>
			<div class="fixed-table-container">
				<div class="table-wrapper" style="height: 95%">
					<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
						<colgroup>
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col style="width: 15%" />
							<col style="width: 5%" />
							<col style="width: 15%" />
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col />
						</colgroup>

						<thead>
							<tr>
								<th>Received Date</th>
								<th>SH NO</th>
								<th>Vendor</th>
								<th>Vendor</th>
								<th>Delivery</th>
								<th>Delivery</th>
								<th>Carton</th>
								<th>Qty</th>
								<th>Amount</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="shipment in root.value.list" v-bind:key="shipment.sh_no">
								<td class="al_center">{{ shipment.received_date }}</td>
								<td class="al_center">
									<a href="javascript:void(0)" @click="shipmentGo(shipment.sh_no)">{{ shipment.sh_dn }} </a>
								</td>
								<td class="al_left">{{ shipment.vendor_code }}</td>
								<td class="al_left">{{ shipment.vendor_name }}</td>
								<td class="al_center">{{ shipment.delivery_place_code }}</td>
								<td class="al_left">{{ shipment.delivery_place_name }}</td>
								<td class="al_right">{{ shipment.carton | commaSeparated }}</td>
								<td class="al_right">{{ shipment.received_quantity | commaSeparated }}</td>
								<td class="al_right">{{ shipment.received_amount | toCurrency }}</td>
								<td class="al_left truncate">{{ shipment.description }}</td>
							</tr>
							<tr>
								<td colspan="6"></td>
								<td class="al_right">{{ root.value.carton | commaSeparated }}</td>
								<td class="al_right">{{ root.value.qty | commaSeparated }}</td>
								<td class="al_right">{{ root.value.amount | toCurrency }}</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { daysAgo, today } from '@/utils/date';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import { objectToFormData, shipmentPageGo } from '@/api/util';
import { apiReceivedList } from '@/api/purchase/purchase';
import { exportExcel } from '@/api/util';

export default {
	data: function() {
		return {
			fromDate: daysAgo(6),
			toDate: today(),
			vendorCode: null,
			root: {
				value: {
					list: [],
				},
			},
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		PartnerSelect,
	},
	methods: {
		setPartner(partner) {
			this.vendor_code = partner.code;
			this.search();
		},
		reset() {
			this.fromDate = this.user.company_id == 'he' ? daysAgo(365) : daysAgo(6);
			this.toDate = today();
			this.vendor_code = null;
		},
		async search() {
			const paramObj = {
				fromDate: this.fromDate,
				toDate: this.toDate,
				vendorCode: this.vendorCode,
			};
			const param = objectToFormData(paramObj);
			var { data } = await apiReceivedList(param);

			//console.log(data.value.list);
			//console.log(data);
			if (!this.user.po_price_view) {
				data.value.amount = null;
				data.value.list.forEach(l => {
					l.received_amount = null;
					l.vendor_code = null;
					l.vendor_name = null;
				});
			}

			this.root = data;
		},
		excel() {
			const eid = 'excelTable';
			const fileName = 'ReceivedList_' + this.fromDate + '_' + this.toDate;
			exportExcel(eid, fileName);
		},
		shipmentGo(shipmentNo) {
			shipmentPageGo(shipmentNo);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_receivedList');
		this.$store.commit('setSubTitle', 'Purchase -> Received List');

		if (this.user.company_id == 'he') this.fromDate = daysAgo(365);
	},
	mounted() {},
};
</script>

<style></style>
